import * as React from 'react'

import Dashboard from '@material-ui/icons/Dashboard'
import Person    from '@material-ui/icons/Person'

import { AccountType }         from '../api'
import {
  Account,
  Companies,
  EditPersonalInformation,
  Users,
}                              from '../components/environments'
import App                     from '../components/environments/App'
import { Routing, SubRouting } from '../types'
import ProgramRouting          from './ProgramRouting'

const dashboardRouting: SubRouting = [
  {
    name:      'programs',
    path:      '/programs',
    component: ProgramRouting,
  },
  {
    name:      'companies',
    path:      '/companies',
    component: Companies,
  },
  {
    name:      'mentors',
    path:      '/mentors',
    component: () => <Users accountType={AccountType.Mentor} />,
  },
  {
    name:      'mentees',
    path:      '/mentees',
    component: () => <Users accountType={AccountType.Mentee} />,
  },
]

const profileRouting = [
  {
    name:      'personal',
    path:      '/personal',
    component: EditPersonalInformation,
  },
  {
    name:      'account',
    path:      '/account',
    component: Account,
  },
]


const routing: Routing = [
  {
    name:       'dashboard',
    path:       '/dashboard',
    icon:       <Dashboard />,
    subrouting: dashboardRouting,
  },
  {
    name:       'profile',
    path:       '/profile',
    icon:       <Person />,
    subrouting: profileRouting,
  }
]

export default () => <App routing={routing} />



// WEBPACK FOOTER //
// ./src/routing/BLCMentoring.tsx